import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

export const viewPayrollOrderQuery = gql`
  query ViewPayrollOrder($order_number: ID!) {
    viewPayrollOrder(order_number: $order_number) {
      id
      client_id
      employee_id
      title
      first_name
      surname
      email
      effective_date
      total_amount_to_recover
      amount_per_pay_period
      order_number
      duration
      benefit_type
      mobile_number
      address1
      address2
      city
      county
      postcode
      ni_number
      date_of_birth
      job_title
      job_location
      job_grade
      partner_user_identifier
      approval_status
      order_status
      basic_details_check_complete
      order_details_check_complete
      national_minimum_wage_check_complete
      telephone_number
      benefit_name
      total_end_of_agreement_inc_vat
      pay_frequency
      products {
        item_no
        item_name
        item_description
        item_qty
        item_value
      }
      line_manager_name
      line_manager_email
      comments {
        name
        comment
        partner_user_id
        created_at
      }
      national_minimum_wage
    }
  }
`

export const getViewPayrollOrderQueryKey = getQueryNames(viewPayrollOrderQuery)[0]
